module.exports = __webpack_public_path__ + "static/media/slider2.e7f6048f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider2.jpeg
// module id = 303
// module chunks = 0